import type { AppDefinition } from '../types';

import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import type { VerboPayload } from './types';

/**
 * Verbos — what the verb means, and how it goes.
 *
 * The Portuguese mirror of the German Verbs deck, with one addition the German
 * one does not have: the card back prints the full conjugation with the endings
 * picked out, so `comer` teaches `com|o`, `com|e`, `com|emos`, `com|em` rather
 * than a single gloss.
 *
 * That raises what a wrong form costs — it is reprinted under every correct
 * answer for that verb, not seen once — so nothing here is authored. The
 * conjugation is derived at seed time by the same engine the Gramática course
 * runs on, whose output is checked against accented Brazilian news text, and a
 * verb it cannot reach fails the seed rather than shipping an empty table.
 */
export const verbosApp: AppDefinition<VerboPayload> = {
  id: 'verbos',
  display_name: 'Verbos',
  CardFront,
  CardBack,
};
